import {
  ArrowBackIos,
  ArrowForwardIos,
  ArrowLeft,
  ArrowRight,
} from "@mui/icons-material";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import SearchListCardItem from "pages/search-listing/search-list-card-item";
import { useAppSelector } from "store/appHooks";
import { getAuthUserId } from "utils/auth.util";

const RelatedSection = () => {
  const { listingDetails }: any = useAppSelector(
    (state) => state.searchListingReducer
  );

  const handleScrollRight = () => {
    var scrollableDiv: any = document.getElementById(
      "related-scrolling-content"
    );
    scrollableDiv.scrollTo({
      left: scrollableDiv.scrollLeft + 150, // Adjust the scroll amount as needed
      behavior: "smooth",
    });
  };

  const handleScrollLeft = () => {
    var scrollableDiv: any = document.getElementById(
      "related-scrolling-content"
    );
    scrollableDiv.scrollTo({
      left: scrollableDiv.scrollLeft - 150, // Adjust the scroll amount as needed
      behavior: "smooth",
    });
  };

  if (listingDetails?.related?.length === 0) return <></>;

  if (listingDetails?.user?.firebase_id === getAuthUserId()) return <></>;

  return (
    <Box sx={{ background: "#FBFFF3", py: "50px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mx: "2%",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              md: "40px",
              lg: "40px",
              xl: "40px",
              sm: "16px",
              xs: "16px",
            },
            lineHeight: "18px",
            fontWeight: 600,
          }}
        >
          Attachments Offered From Same Owner
        </Typography>

        <Box
          sx={{
            display: {
              md: "flex",
              lg: "flex",
              xl: "flex",
              sm: "none",
              xs: "none",
            },
            gap: "10px",
          }}
        >
          <IconButton onClick={handleScrollLeft}>
            <img
              src="/assets/img/icons/forward_cr_green.svg"
              alt=""
              width="48"
              height="48"
            />
          </IconButton>

          <IconButton onClick={handleScrollRight}>
            <img
              src="/assets/img/icons/back_cr_green.svg"
              alt=""
              width="48"
              height="48"
            />
          </IconButton>
        </Box>
      </Box>

      <Box
        id="related-scrolling-content"
        sx={{
          mt: "40px",
          overflow: "auto",

          display: "flex",
          flex: 1,

          pl: "25px",
        }}
      >
        {listingDetails?.related?.length === 0 && (
          <Box sx={{ my: "20px", mx: "1%" }}>
            <Typography> No related listings found.</Typography>
          </Box>
        )}
        {listingDetails?.related?.map((r: any) => (
          <Box
            sx={{
              width: {
                md: "312px !important",
                lg: "312px !important",
                xl: "312px !important",
                sm: "160px !important",
                xs: "160px !important",
              },
              minWidth: {
                md: "312px !important",
                lg: "312px !important",
                xl: "312px !important",
                sm: "160px !important",
                xs: "160px !important",
              },
              maxWidth: {
                md: "312px !important",
                lg: "312px !important",
                xl: "312px !important",
                sm: "160px !important",
                xs: "160px !important",
              },
              mr: {
                md: "25px",
                lg: "25px",
                xl: "25px",
                sm: "10px",
                xs: "10px",
              },
              flex: 1,
            }}
          >
            <SearchListCardItem
              {...{
                ...r,
                ...r?.listing_features?.[0],
                background: "transparent",
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RelatedSection;
